export const VALIDATE = "validar.VALIDATE";
export const SET_TOKEN_RECAPTCHA =
  "validar.CRACHA_AMBULANTE_SET_TOKEN_RECAPTCHA";
export const SET_FROM_QUERY_STRING = "validar.SET_FROM_QUERY_STRING";
export const SET_DADOS_AMBULANTE = "SET_DADOS_AMBULANTE";
export const GET_DADOS_AMBULANTE = "GET_DADOS_AMBULANTE";
